import Sidebar from './SideBar.vue';
import SidebarItem from './SidebarItem.vue';
import delay from 'yoctodelay';

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar(value: any) {
    this.showSidebar = value;
  },
  async toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    await delay(1000);

    clearInterval(simulateWindowResize);

    this.isMinimized = !this.isMinimized;
  },
};

const SidebarPlugin = {
  install(app: any, options: any) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }

    app.mixin({
      data() {
        return {
          sidebarStore: SidebarStore,
        };
      },
    });

    app.config.globalProperties.$sidebar = SidebarStore;
    // Object.defineProperty(app.prototype, '$sidebar', {
    //   get () {
    //     return this.$root.sidebarStore
    //   }
    // })
    app.component('SideBar', Sidebar);
    app.component('SidebarItem', SidebarItem);
  },
};

export default SidebarPlugin;
